module.exports = "<div id=\"extr-page\">\n<router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/alex/Documents/JC/JC3 3/src/app/shared/layout/app-layouts/auth-layout.component.html
// module id = ../../../../../src/app/shared/layout/app-layouts/auth-layout.component.html
// module chunks = main